import MerchantDetails from './merchant-details.vue';

export default MerchantDetails;
